<div class="contenido" style="background: #F6F6F6;">

    <!--  Avance:{{dblAvance}} -->
    <div class="container" style="background: #F6F6F6;">
      <div class="row pt-3 d-flex justify-content-between">
        <div class="col-12">
          <div class="row d-flex justify-content-around">
            <div class="card col-12 col-lg-3 px-0">
              <div class="card-header py-1">
                <div class="col-12 text-center px-0"><label class="h5 mb-0">Filtrado Articulo</label></div>
              </div>
              <div class="card-body row py-3">
                <div class="col-12">
                  <input class="form-control me-sm-2" [(ngModel)]="strBusqueda" type="search" placeholder="Buscar"
                    aria-label="Search">
                </div>
              </div>
            </div>
            <div class="card col-12 mt-3 mt-lg-0 col-lg-8 px-0">
              <div class="card-header py-1">
                <div class="col-12 text-center"><label class="h5 mb-0"> Filtrado</label></div>
              </div>
              <div class="card-body row py-3">
                <div class="col-12 col-md-6">
                  <div class="input-group">
                    
                      <label class="input-group-text" for="inputGroupSelect01">Origen</label>
                    
                    <select class="form-select" id="inputGroupSelect01" [(ngModel)]="almacenOrigen">
                      <option value="-1" selected>--Todos--</option>
                      <option value="{{A.strAlmacen}}" *ngFor="let A of arrayEncabezados">{{A.strNombreAlm}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 my-3 my-md-0 col-md-6">
                  <div class="input-group">
                   
                      <label class="input-group-text" for="inputGroupSelect01">Destino</label>
                   
                    <select class="form-select" id="inputGroupSelect01" [(ngModel)]="almacenDestino">
                      <option value="-1" selected>--Todos--</option>
                      <option value="{{A.strAlmacen}}" *ngFor="let A of arrayEncabezados">{{A.strNombreAlm}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" *ngIf="spiner">
        <div class="row py-4">
          <div class="col-12 d-flex justify-content-center">
            <mat-spinner></mat-spinner>
          </div>
        </div>
        
      </div>
      <div class="row" *ngIf="!spiner">
        <!--  <div  *ngFor="let alm of arrayEncabezadoOrigen | filtrarAlmOriDes:almacenOrigen:'strAlm_Origen' "> -->
        <!-- <b>{{alm.strAlm_Origen}}{{alm.strAlm_OrigenNombre}}</b>  |filtrarAlmOrigen:almD.strAlm_Origen  filtrarAlmOriDes:almacenDestino :'strAlm_destino' | -->
        <div class="col-12 table-container" *ngFor="let almD of arrayEncabezadoDestino| filtrarAlmOrigenDestino:almacenOrigen:almacenDestino; let ind = index;">
          <!--  {{almD.strAlm_destino}}{{almD.strAlm_destinoNombre}} -->
          <!--  <ng-container *ngIf="tieneRegistros(alm.strAlm_Origen, almD.strAlm_destino)"> *ngIf="tieneRegistros(alm.strAlm_Origen, almD.strAlm_destino)" -->
          <div class="mt-5" *ngIf="almD.arrayresult.length>0 && (almD.arrayresult | filtrarAlmArticulos: strBusqueda).length > 0 ">
            <div class="table-responsive mb-0 col-12 px-0 rounded shadow-sm">
              <table class="table w-100 rounded table-hover table-bordered sombra  mb-0" id="tabla">
                <thead class="topsticky">
                  <tr class="cabeceraTransitos">
                    <th class="text-center" colspan="10">
                      <div class="row w-100 align-items-center">
                        <div class="col-3">
                          <label for="" class="bg-light mb-0 shadow p-1 rounded text-dark d-flex align-items-center fw-light">
                            <span>Origen:</span>
                            <select class="form-select  fw-bold" [(ngModel)]="almD.strAlm_Origen"
                              (change)="cambia_alm_origen(almD)">
                              <option selected value="{{almD.strAlm_Origen}}">
                                ({{almD.strAlm_Origen}}){{almD.strAlm_OrigenNombre}}</option>
                              <!--<ng-container ></ng-container>-->
                              <option *ngFor="let A of arrayEncabezados"
                                [ngClass]="{'d-none':A.strAlmacen == almD.strAlm_Origen}" value="{{A.strAlmacen}}">
                                ({{A.strAlmacen}}){{A.strNombreAlm}}</option>
                            </select>
                          </label>
                        </div>
                        <div class="col-1 d-flex justify-content-center align-items-center">
                          <button class="mx-2 btn p-0 d-flex align-items-center shadow btnblues"style="max-width:40px"><!-- (click)="fnCambiarArrayDestino(ind)" -->
                            <mat-icon class="col-12 p-0">keyboard_arrow_right</mat-icon>
                          </button>
                        </div>
                        <div class="col-3">
                          <label for="" class="col-12 d-flex align-items-center bg-light mb-0 shadow p-1 rounded text-dark fw-light">
                            <span>Destino:</span>
                             <label class="mb-0 text-dark rounded p-1 fw-bold">
                               <ng-container *ngIf="almD.flecha === 1">
                                 ({{almD.strAlm_Origen}}) {{almD.strAlm_OrigenNombre}}
                               </ng-container>
                               <ng-container *ngIf="almD.flecha === 0">
                                 ({{almD.strAlm_destino}}){{almD.strAlm_destinoNombre}}
                               </ng-container>
                             </label>
                           </label>
                        </div>
                        <div class="col-1">
                        </div>
                        <div class="col-4">
                          <div class="input-group">
                            <!-- <button class="btn btn-outline-secondary" type="button">Button</button> -->
                            <select class="form-select" id="inputGroupSelect03" aria-label="Example select with button addon">
                              <option value="0" selected>Sin unificar</option>
                              <ng-container *ngFor="let A of fnunif(arrayEncabezadoDestino,almD.strAlm_Origen)">
                                <option [ngClass]="{'d-none': almD.strAlm_destinoNombre == A.strAlm_destinoNombre }"
                                  value="{{A.strAlm_destino}}"
                                  *ngIf="A.arrayresult.length>0 && (almD.arrayresult | filtrarAlmArticulos: strBusqueda).length>0">
                                  {{A.strAlm_destinoNombre}}</option>
                              </ng-container>
                            </select>
                            <button class="btn btnblues" type="button"
                            [disabled]="almD.alM1P == 0 || almD.alM1P == undefined  || almD.alM1P ==almD.strAlm_destino "
                            (click)="fnUnificar(almD.strAlm_Origen,almD.strAlm_destino,almD.alM1P)">Unificar</button>

                          </div>





                         <!--  <select class="form-select" id="inputGroupSelect01" [(ngModel)]="almD.alM1P">
                            <option value="0" selected>Sin unificar</option>
                            <ng-container *ngFor="let A of fnunif(arrayEncabezadoDestino,almD.strAlm_Origen)">
                              <option [ngClass]="{'d-none': almD.strAlm_destinoNombre == A.strAlm_destinoNombre }"
                                value="{{A.strAlm_destino}}"
                                *ngIf="A.arrayresult.length>0 && (almD.arrayresult | filtrarAlmArticulos: strBusqueda).length>0">
                                {{A.strAlm_destinoNombre}}</option>
                            </ng-container>
                          </select> -->

                         
              
                        </div>
                        
                         
                          <!--  <div class="col-5 text-right"> -->
                           
                          
                          <!--      </div>
                                             <div class="col-1 d-flex align-items-center">  -->
                         
                          <!--    </div> -->
                          <!--  <div class="col-6 text-left d-flex align-items-center">    -->
                       
                          <!--  </div>  -->
                       
                        <!--  <div class="col-3"> -->
  
                        <!--     </div> -->
                      </div>
                    </th>
                  </tr>
                  <tr class="cabeceraTitulo">
                    <th class="text-center"><button class="btn btn-light border-0 p-0 btneliminar"
                        (click)="fndeletearray(almD.strAlm_Origen,almD.objNuevoAlm.strAlm_Origen,almD.strAlm_destino,almD.flecha);"><i
                          class="fa fa-trash text-danger"></i> </button> </th>
                    <th class="text-center">Artículo</th>
                    <th class="text-center">Descripción</th>
                    <th class="text-center">Opcion</th>
                    <th class="text-center">Unidad</th>
                    <th class="text-center">Cantidad</th>
                    <th class="text-center">Volumen</th>
                    <th class="text-center">Volumen Total</th>
                    <th class="text-center">Peso</th>
                    <th class="text-center">Peso Total</th>
                  </tr>
                </thead>
                <tbody class="">
                  <ng-container *ngIf="almD.flecha === 0">
                    <tr *ngFor="let registro of almD.arrayresult  | filtrarAlmArticulos: strBusqueda; let i = index">
                      <td class="text-center align-middle">
                        <div class=" d-flex justify-content-center align-items-center">
                          <a class="d-flex" (click)="fnEliminar(almD.strAlm_Origen,almD.strAlm_destino,i,registro.strArticulo,registro.strNombreOpcion)">
                            <i class="bi bi-x-circle-fill fs-4 text-danger  mx-auto"></i><!-- <i class="fa fa-circle-xmark colorR"></i> --></a>
                        </div>
                      </td>
                      <td class="text-left"><span [title]="registro.strCaso">{{registro.strArticulo}}</span> </td>
                      <td class="text-left text-nowrap fzTbl12" [innerHTML]="formatDescripcion(registro.strDescripcion)">
                      </td>
                      <td class="text-left">{{registro.strNombreOpcion}} <span
                          *ngIf="registro.strOpcion!=''">({{registro.strOpcion}})</span> </td>
                      <td class="text-center">{{registro.strUnidad}} </td>
                      <td class="text-right"><input class="text-right ps-1 form-control" style="max-width: 110px;" type="number"
                          [(ngModel)]="registro.dblCantidad" (change)="cambiarCantidad(registro , registro.dblCantidad)"
                          min="1"></td>
                      <td class="text-right">{{registro.dblVolumen | number:'1.2-2'}}
                      </td>
                      <td class="text-right">{{(registro.dblVolumen*registro.dblCantidad) | number:'1.2-2'}}
                      </td>
                      <td class="text-right">{{registro.dblPeso | number:'1.2-2'}}
                      </td>
                      <td class="text-right">{{(registro.dblPeso*registro.dblCantidad) | number:'1.2-2'}}
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="almD.flecha === 1">
                    <tr
                      *ngFor="let registro of almD.arrayresultVuelta  | filtrarAlmArticulos: strBusqueda | filtrarAlmOrigenDestino:almacenOrigen:almacenDestino; let i = index;">
                      <td class="text-center"><a
                          (click)="fnEliminar(almD.strAlm_Origen,almD.strAlm_destino,i,registro.strArticulo,registro.strNombreOpcion)">
                          <img src="assets/img/cancel.svg"
                            alt=""><!-- <i class="fa-solid fa-circle-xmark colorR"></i> --></a></td>
                      <!-- <td class="text-center"><a (click)=" fnEliminarObjeto(almD.strAlm_destino, alm.strAlm_Origen,registro.strArticulo,registro.strOpcion)"><i class="fa-solid fa-circle-xmark colorR"></i></a></td> -->
                      <td class="text-left"><span [title]="registro.strCaso">{{registro.strArticulo}}</span> </td>
                      <td class="text-left text-nowrap fzTbl12">{{registro.strDescripcion}}</td>
                      <td class="text-left">{{registro.strNombreOpcion}} <span
                          *ngIf="registro.strOpcion!=''">({{registro.strOpcion}})</span> </td>
                      <td class="text-center">{{registro.strUnidad}} </td>
                      <td class="text-right"><input class="text-right" type="number" [(ngModel)]="registro.dblCantidad"
                          (change)="cambiarCantidad(registro , registro.dblCantidad)" min="1"></td>
                      <td class="text-right">{{registro.dblVolumen | number:'1.2-2'}}
                      </td>
                      <td class="text-right">{{(registro.dblVolumen*registro.dblCantidad) | number:'1.2-2'}}
                      </td>
                      <td class="text-right">{{registro.dblPeso | number:'1.2-2'}}
                      </td>
                      <td class="text-right">{{(registro.dblPeso*registro.dblCantidad) | number:'1.2-2'}}
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <tfoot class="topstickyfoot " >
                  <ng-container *ngIf="almD.flecha === 0">
                    <tr class="bgfoot">
                      <td colspan="5">
                        <div class="row d-flex justify-content-center align-items-center">
                          <div class="col-5 d-flex justify-content-center pe-0">
                            <button type="button" class="btn btn-primary px-1 fz14"
                              (click)="fnSetTransito(almD.strAlm_Origen,almD.objNuevoAlm.strAlm_Origen,almD.strAlm_destino,almD.vehiculoSeleccionado,almD.flecha)">Generar
                              Transito</button>
                          </div>
                        </div>
                      </td>
                      <td class="">
                        <div class="col-12 d-flex justify-content-end text-right">
                          <label class="mb-0 text-white rounded p-1 fw-light cabeceraTransitos">
                            {{sumarCantidad( almD.strAlm_Origen,almD.strAlm_destino,ind,almD.flecha)}}
                          </label>
                        </div>
                      </td>
                      <td class="text-right ">
                        <label class="mb-0 text-white rounded p-1 fw-light text-nowrap cabeceraTransitos">
                          {{ sumarVolumen( almD.strAlm_Origen,almD.strAlm_destino,ind,almD.flecha)| number:'1.2-2' }} m3
                        </label>
                      </td>
                      <td class="text-right ">
                        <label class="mb-0 text-white rounded p-1 fw-light text-nowrap cabeceraTransitos">
                          {{ sumarVolumenT( almD.strAlm_Origen,almD.strAlm_destino,almD.flecha)| number:'1.2-2' }} m3
                        </label>
                      </td>
                      <td class="text-right ">
                        <label class="mb-0 text-white rounded p-1 fw-light text-nowrap cabeceraTransitos">
                          {{ sumarPeso( almD.strAlm_Origen,almD.strAlm_destino,ind,almD.flecha)| number:'1.2-2' }} kg
                        </label>
                      </td>
                      <td class="text-right ">
                        <label class="mb-0 text-white rounded p-1 fw-light cabeceraTransitos">
                          {{ sumarPesoT( almD.strAlm_Origen,almD.strAlm_destino,ind,almD.flecha)| number:'1.2-2' }}
                        </label>
                      </td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="almD.flecha === 1">
                    <tr>
                      <td colspan="5">
                        <div class="row d-flex">
                          <div class="col-4 d-flex justify-content-center pe-2">
                            <div class="input-group ">
                              
                                <label class="input-group-text cabeceraTransitos"
                                  for="inputGroupSelect01">Vehículos</label>
                              
                              <select class="form-select" id="inputGroupSelect01"
                                [(ngModel)]="almD.vehiculoSeleccionado">
                                <!--   <option [ngValue]="almD.vehiculoSeleccionado">--Selecciona una opción--</option>-->
                                <option *ngFor="let item of almD.arrayVehiculos" [ngValue]="item">
                                  {{ item.strDescripcion }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-5 px-0 mx-0 ">
                            <div class="row d-flex align-items-center justify-content-between">
                              <div class="col-6 text-dark  fz12 pe-1" style="max-height:30px">
                                <b>{{almD.vehiculoSeleccionado?.strVehiculo}}</b>
                                {{almD.vehiculoSeleccionado?.strEstatus}} {{almD.vehiculoSeleccionado?.dblPeso |
                                number:'1.2-2' }}
                              </div>
  
                              <div class="col-6   d-flex justify-content-center pe-0 ps-1 pe-0">
                                <label class="col-12 mb-0 cabeceraTransitos p-1  rounded fw-light">
                                  {{almD.vehiculoSeleccionado?.dblVolumen| number:'1.2-2'}} >
                                  {{ sumarVolumenT(almD.strAlm_Origen,almD.strAlm_destino,almD.flecha)
                                  | number:'1.2-2' }} m3
                                  <mat-icon *ngIf="almD.vehiculoSeleccionado?.dblVolumen >
                                                            (   sumarVolumenT(almD.strAlm_Origen, almD.strAlm_destino,almD.flecha) )
                                                            && almD.vehiculoSeleccionado?.dblVolumen != ' '"
                                    class="text-success rounded-circle bg-white align-middle">check_box</mat-icon>
                                  <mat-icon *ngIf="almD.vehiculoSeleccionado?.dblVolumen <
                                                            (   sumarVolumenT( almD.strAlm_Origen, almD.strAlm_destino,almD.flecha ) )
                                                              && almD.vehiculoSeleccionado?.dblVolumen != ' '"
                                    class="text-danger rounded-circle bg-white align-middle">cancel</mat-icon>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-3 d-flex justify-content-center pe-0">
                            <button type="button" class="btn btnblues px-1 fz14"
                              (click)="fnSetTransito(almD.strAlm_Origen,almD.objNuevoAlm.strAlm_Origen,almD.strAlm_destino,almD.vehiculoSeleccionado,almD.flecha)"
                              [disabled]="sumarVolumenT( almD.strAlm_Origen,almD.strAlm_destino,almD.flecha)>90">Generar
                              Transito</button>
                          </div>
                        </div>
  
                      </td>
  
                      <td class="">
                        <div class="col-12 d-flex justify-content-end text-right">
                          <label class="mb-0 text-white rounded p-1 fw-light cabeceraTransitos">
                            {{sumarCantidad( almD.strAlm_Origen, almD.strAlm_destino ,ind,almD.flecha )}}
                          </label>
                        </div>
                      </td>
                      <td class="text-right ">
                        <label class="mb-0 text-white rounded p-1 fw-light text-nowrap cabeceraTransitos">
                          {{ sumarVolumen( almD.strAlm_Origen,almD.strAlm_destino ,ind,almD.flecha)| number:'1.2-2' }} m3
                        </label>
                      </td>
                      <td class="text-right ">
                        <label class="mb-0 text-white rounded p-1 fw-light text-nowrap cabeceraTransitos">
                          {{ sumarVolumenT(almD.strAlm_Origen ,almD.strAlm_destino,almD.flecha)| number:'1.2-2' }} m3
                        </label>
                      </td>
                      <td class="text-right ">
                        <label class="mb-0 text-white rounded p-1 fw-light text-nowrap cabeceraTransitos">
                          {{ sumarPeso(almD.strAlm_Origen ,almD.strAlm_destino,ind,almD.flecha)| number:'1.2-2' }} kg
                        </label>
                      </td>
                      <td class="text-right ">
                        <label class="mb-0 text-white rounded p-1 fw-light cabeceraTransitos">
                          {{ sumarPesoT(almD.strAlm_Origen ,almD.strAlm_destino,ind,almD.flecha)| number:'1.2-2' }}
                        </label>
                      </td>
                    </tr>
                  </ng-container>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  
  
  
    <!--MODAL-->
    <ng-template #listaArticulos let modal>
      <div class="modal-header">
        <h4 class="modal-title">
          <i class="fa-solid fa-box"></i>
          &nbsp;&nbsp;
          <span>Listado de Artículos</span>
        </h4>
        <button class="btn-close" aria-label="close" type="button" (click)="cerrarModal()">
          <span aria-hidden="true">&times;</span>
        </button>
  
      </div>
      <div class="modal-body">
        <mat-form-field appearance="outline">
          <mat-label>Articulos</mat-label>
          <mat-select [(ngModel)]="strArticulo" #singleSelectS>
            <mat-label>Selecciona una opción</mat-label>
            <mat-option value="{{articulo.strArticulo}}"
              *ngFor="let articulo of ArrayArticulos">{{articulo.strArticulo}}</mat-option>
  
          </mat-select>
        </mat-form-field>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="fnAgregaArticulo()">AgregarArticulo</button>
        <button type="button" class="btn btn-danger" (click)="cerrarModal()">Cerrar</button>
  
      </div>
    </ng-template>
    <!--MODAL-->
  
  </div>
  